import { Route } from '@angular/router';
import { roleCanMatch } from '../../../../libs/core';

export const appRoutes: Route[] = [
	{
		path: '',
		pathMatch: 'full',
		redirectTo: 'login'
	},
	{
		path: 'login',
		loadComponent: () =>
			import('./features/portal-login-page.component').then((m) => m.PortalLoginPageComponent)
	},
	{
		path: 'dashboard',
		canMatch: [roleCanMatch('customer')],
		loadComponent: () =>
			import('./features/portal-dashboard-page.component').then((m) => m.PortalDashboardPageComponent)
	},
	{
		path: 'error/:code',
		loadComponent: () =>
			import('../../../../libs/core/shared/ui/error-reusable/error-reusable').then((m) => m.ErrorReusableComponent)
	},
	{
		path: '**',
		pathMatch: 'full',
		redirectTo: 'error/404'
	}
];
